import React from 'react'

const InfoPopup = (props) => {
  return (
    <div className="popup" onClick={props.closePopup}>
      <div className="info-popup">
        <h1 className="align-center blue-color">Easy and Simple</h1>
        <h3 className="align-center dat-grey">Complete the Quiz by Selecting the Answer<br />That Suits Best Your Situation</h3>
        <button onClick={props.closePopup} className="close-button">×</button>
        <img alt="popup" className="popup-pic" src={require("../assets/imgs/info-popup.png")} />
      </div>
    </div>
  )
}

export default InfoPopup